(() => {
  if (window.__productGalleryFullbleed) return;
  window.__productGalleryFullbleed = true;

  const mq = window.matchMedia('(max-width: 749px)');
  const FULLBLEED_FROM = 2;
  let ticking = false;
  let observedList = null;

  const galleryEl = () => document.querySelector('[data-sp-fullbleed="true"]');

  const headerHeight = () =>
    parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height-sp')) || 65;

  const slidesOf = (gallery) => {
    const list = gallery.querySelector('[id^="Slider-Gallery"]');
    if (!list) return [];
    return Array.from(list.querySelectorAll(':scope > .product__media-item'));
  };

  const mostVisibleIndex = (slides) => {
    const center = window.innerWidth / 2;
    let bestIndex = 0;
    let bestDist = Infinity;
    slides.forEach((slide, index) => {
      const rect = slide.getBoundingClientRect();
      if (rect.width <= 0) return;
      const dist = Math.abs((rect.left + rect.right) / 2 - center);
      if (dist < bestDist) {
        bestDist = dist;
        bestIndex = index;
      }
    });
    return bestIndex;
  };

  const mediaUnderHeader = (gallery) => {
    const list = gallery.querySelector('[id^="Slider-Gallery"]');
    if (!list) return false;
    const rect = list.getBoundingClientRect();
    return rect.top < headerHeight() && rect.bottom > headerHeight();
  };

  const setState = (slideActive, headerOver) => {
    document.body.classList.toggle('sp-fullbleed-slide', slideActive);
    document.body.classList.toggle('header-over-fullbleed', headerOver);
  };

  const update = () => {
    const gallery = galleryEl();
    const menuOpen = document.querySelector('.mobile-menu.is-active');

    if (!gallery || !mq.matches) {
      setState(false, false);
      return;
    }

    const slides = slidesOf(gallery);
    if (slides.length < 3) {
      setState(false, false);
      return;
    }

    const slideActive = mostVisibleIndex(slides) >= FULLBLEED_FROM;
    const headerOver = slideActive && !menuOpen && mediaUnderHeader(gallery);
    setState(slideActive, headerOver);
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      update();
    });
  };

  const intersectionObserver = new IntersectionObserver(requestUpdate, {
    root: null,
    threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
  });

  const observeSlider = () => {
    const gallery = galleryEl();
    const list = gallery?.querySelector('[id^="Slider-Gallery"]') || null;
    if (observedList === list) return;

    if (observedList) {
      observedList.removeEventListener('scroll', requestUpdate);
      intersectionObserver.unobserve(observedList);
    }

    observedList = list;
    if (!list) return;

    list.addEventListener('scroll', requestUpdate, { passive: true });
    intersectionObserver.observe(list);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  mq.addEventListener('change', requestUpdate);
  document.addEventListener('slideChanged', requestUpdate, true);
  document.addEventListener('shopify:section:load', () => {
    observeSlider();
    requestUpdate();
  });

  const start = () => {
    const menu = document.querySelector('.mobile-menu');
    if (menu) {
      new MutationObserver(requestUpdate).observe(menu, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }
    observeSlider();
    requestUpdate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
